import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { translationKeys } from '@gik/contact/i18n/en';
import { translationKeys as commonTranslationKeys } from '@gik/i18n/en/common';
import { useTranslation } from 'react-i18next';
import Form from '@gik/ui/Form';
import { contactFormSchema } from '@gik/contact/formSchemas';
import { sendContact } from '@gik/contact/api/ContactAPI';
import { ContactFormInputNames } from '@gik/contact/enums/ContactFormInputNames';

export interface IContactFormProps {}

const blockName = 'contact-form';

export interface ISendContactFormValues {
  [ContactFormInputNames.Name]: string;
  [ContactFormInputNames.EmailAddress]: string;
  [ContactFormInputNames.Message]: string;
  [ContactFormInputNames.SignUpNewsletter]: boolean;
}

export function ContactForm(_props: IContactFormProps) {
  const bem = useBemCN(blockName);
  const { t } = useTranslation();

  const [error, setError] = React.useState<boolean>(false);
  const [finished, setFinished] = React.useState<boolean>(false);

  async function onClickSend(values: ISendContactFormValues) {
    if (values) {
      try {
        await sendContact(values);
      } catch (e) {
        setError(true);
      } finally {
        setFinished(true);
      }
    }
  }

  return (
    <section {...bem()}>
      {finished ? (
        <>{error ? <p>{t(translationKeys.ContactFormError)}</p> : <p>{t(translationKeys.ContactFormSent)}</p>}</>
      ) : (
        <>
          <h2 {...bem('form-heading')}>{t(translationKeys.FormHeading)}</h2>
          <p {...bem('form-subheading')}>{t(translationKeys.FormSubheading)}</p>

          <Form
            schema={contactFormSchema}
            initialValues={{
              [ContactFormInputNames.SignUpNewsletter]: true,
            }}
            vertical
            submitButton
            submitButtonText={t(commonTranslationKeys.send)}
            onSubmit={onClickSend}
          />
        </>
      )}
    </section>
  );
}
